import { Component, OnInit } from '@angular/core';
import { FormField } from '../../../dto/util/form-field';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, Validators } from '@angular/forms';
import { Constants } from '../../../constants/constants';
import { AdministracionUsuariosService } from '../services/administracion-usuarios.service';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { RespuestaDataUsuarioDTO } from '../models/respuestaDTO';
import { ModificarAdminDTO } from '../models/crearAdminDTO';
import { TranslateService } from '@ngx-translate/core';
import { AutenticacionService } from '../../auth/services/autenticacion.service';

@Component({
  selector: 'app-modificar-administrador',
  templateUrl: './modificar-administrador.component.html',
  styleUrl: './modificar-administrador.component.scss',
})
export class ModificarAdministradorComponent implements OnInit {
  // Campos formularios
  camposAdminLider: FormField[] = [];
  camposAdminFuncional: FormField[] = [];

  // Boolean
  esAdminLider = false;
  esAdminFuncional = false;

  // Number
  idUsuario!: number;

  // DTO
  dataUsuario!: RespuestaDataUsuarioDTO;

  // Multilenguaje
  tableText: any = {};

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private adminService: AdministracionUsuariosService,
    private alertService: AlertaModalService,
    private translate: TranslateService,
    private autenticacionService: AutenticacionService,
    private alertaModalService: AlertaModalService
  ) {
    this.route.params.subscribe(params => {
      this.idUsuario = params['idUsuario'];
    });
  }

  ngOnInit(): void {
    // Cargar data de usuario por ID
    this.adminService.usuarioPorID(this.idUsuario).subscribe(resp => {
      if (resp.status === 200) {
        this.dataUsuario = resp;
        // Se valida la ruta, para verificar si es admin líder o admin funcional
        if (this.router.url.includes('lider')) {
          this.esAdminLider = true;
          this.esAdminFuncional = false;
          this.inicializarFormLider();
        } else if (this.router.url.includes('funcional')) {
          this.esAdminFuncional = true;
          this.esAdminLider = false;
          this.inicializarFormFuncional();
        }
      } else {
        this.alertService.error(resp.message);
      }
    });
    // Multilenguaje
    this.translate.stream('crear-administrador').forEach(text => {
      for (const key of Object.keys(text)) {
        this.tableText[key] = text[key];
      }
      if (this.esAdminFuncional) {
        this.inicializarFormFuncional();
      }
      if (this.esAdminLider) {
        this.inicializarFormLider();
      }
    });
  }

  // Se inicializa formulario de admin líder
  inicializarFormLider() {
    this.camposAdminLider = [
      {
        name: 'id',
        label: '',
        type: 'text',
        visible: false,
        value: this.dataUsuario.data.Usuario.Id,
      },
      {
        name: 'primerNombre',
        label: this.tableText['primer-nombre'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(50),
          Validators.pattern(
            Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS
          ),
        ],
        value: this.dataUsuario.data.Persona_Natural[0].Primer_nombre,
        errorMessages: {
          required: this.tableText['campo-requerido'],
          maxlength: this.tableText['max-50'],
          pattern: this.tableText['formato-invalido'],
        },
      },
      {
        name: 'segundoNombre',
        label: this.tableText['segundo-nombre'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.maxLength(50),
          Validators.pattern(
            Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS
          ),
        ],
        value: this.dataUsuario.data.Persona_Natural[0].Segundo_nombre,
        errorMessages: {
          maxlength: this.tableText['max-50'],
          pattern: this.tableText['formato-invalido'],
        },
      },
      {
        name: 'primerApellido',
        label: this.tableText['primer-apellido'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(50),
          Validators.pattern(
            Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS
          ),
        ],
        value: this.dataUsuario.data.Persona_Natural[0].Primer_apellido,
        errorMessages: {
          required: this.tableText['campo-requerido'],
          maxlength: this.tableText['max-50'],
          pattern: this.tableText['formato-invalido'],
        },
      },
      {
        name: 'segundoApellido',
        label: this.tableText['segundo-apellido'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.maxLength(50),
          Validators.pattern(
            Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS
          ),
        ],
        value: this.dataUsuario.data.Persona_Natural[0].Segundo_apellido,
        errorMessages: {
          maxlength: this.tableText['max-50'],
          pattern: this.tableText['formato-invalido'],
        },
      },
      {
        name: 'correo',
        label: this.tableText['correo'],
        type: 'email',
        required: true,
        width: '6',
        validation: [Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO)],
        value: this.dataUsuario.data.Correo_electronico,
        errorMessages: {
          required: this.tableText['campo-requerido'],
          pattern: this.tableText['correo-invalido'],
        },
        disabled: true,
      },
      {
        name: 'estado',
        label: this.tableText['estado'],
        type: 'select',
        required: true,
        width: '6',
        value: this.dataUsuario.data.Usuario.Estado === true ? 1 : 0,
        options: [
          { Id: 1, Nombre: 'Habilitado' },
          { Id: 0, Nombre: 'Inhabilitado' },
        ],
        validation: [Validators.required],
        errorMessages: {
          required: this.tableText['campo-requerido'],
        },
      },
    ];
  }

  // Se inicializa formulario de admin funcional
  inicializarFormFuncional() {
    this.camposAdminFuncional = [
      {
        name: 'id',
        label: '',
        type: 'text',
        visible: false,
        value: this.dataUsuario.data.Usuario.Id,
      },
      {
        name: 'primerNombre',
        label: this.tableText['primer-nombre'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(50),
          Validators.pattern(
            Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS
          ),
        ],
        value: this.dataUsuario.data.Persona_Natural[0].Primer_nombre,
        errorMessages: {
          required: this.tableText['campo-requerido'],
          maxlength: this.tableText['max-50'],
          pattern: this.tableText['formato-invalido'],
        },
      },
      {
        name: 'segundoNombre',
        label: this.tableText['segundo-nombre'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.maxLength(50),
          Validators.pattern(
            Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS
          ),
        ],
        value: this.dataUsuario.data.Persona_Natural[0].Segundo_nombre,
        errorMessages: {
          maxlength: this.tableText['max-50'],
          pattern: this.tableText['formato-invalido'],
        },
      },
      {
        name: 'primerApellido',
        label: this.tableText['primer-apellido'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(50),
          Validators.pattern(
            Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS
          ),
        ],
        value: this.dataUsuario.data.Persona_Natural[0].Primer_apellido,
        errorMessages: {
          required: this.tableText['campo-requerido'],
          maxlength: this.tableText['max-50'],
          pattern: this.tableText['formato-invalido'],
        },
      },
      {
        name: 'segundoApellido',
        label: this.tableText['segundo-apellido'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.maxLength(50),
          Validators.pattern(
            Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS
          ),
        ],
        value: this.dataUsuario.data.Persona_Natural[0].Segundo_apellido,
        errorMessages: {
          maxlength: this.tableText['max-50'],
          pattern: this.tableText['formato-invalido'],
        },
      },
      {
        name: 'correo',
        label: this.tableText['correo'],
        type: 'email',
        required: true,
        width: '6',
        validation: [Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO)],
        value: this.dataUsuario.data.Correo_electronico,
        errorMessages: {
          required: this.tableText['campo-requerido'],
          pattern: this.tableText['correo-invalido'],
        },
      },
      {
        name: 'estado',
        label: this.tableText['estado'],
        type: 'select',
        required: true,
        width: '6',
        value: this.dataUsuario.data.Usuario.Estado === true ? 1 : 0,
        options: [
          { Id: 1, Nombre: 'Habilitado' },
          { Id: 0, Nombre: 'Inhabilitado' },
        ],
        validation: [Validators.required],
        errorMessages: {
          required: this.tableText['campo-requerido'],
        },
      },
    ];
  }

  onSubmitAdminLider(event: FormGroup) {
    const json: ModificarAdminDTO = {
      usuarioDto: {
        id: event.value.id,
        primerNombre: event.value.primerNombre,
        segundoNombre: event.value.segundoNombre,
        primerApellido: event.value.primerApellido,
        segundoApellido: event.value.segundoApellido,
        email: event.value.correo,
      },
      estado: event.value.estado === 1 ? true : false,
    };
    this.adminService.modificarUsuario(json).subscribe(resp => {
      if (resp.idUsuario) {
        this.alertService.exito(resp.message).then(() => {
          this.router.navigateByUrl(
            'administracion-usuarios/lista-administradores'
          );
        });
      } else {
        this.alertService.error(resp.message);
      }
    });
  }

  onSubmitAdminFuncional(event: FormGroup) {
    const json: ModificarAdminDTO = {
      usuarioDto: {
        id: event.value.id,
        primerNombre: event.value.primerNombre,
        segundoNombre: event.value.segundoNombre,
        primerApellido: event.value.primerApellido,
        segundoApellido: event.value.segundoApellido,
        email: event.value.correo,
      },
      estado: event.value.estado === 1 ? true : false,
    };
    this.adminService.modificarUsuario(json).subscribe(resp => {
      if (resp.idUsuario) {
        this.alertService.exito(resp.message).then(() => {
          this.router.navigateByUrl(
            'administracion-usuarios/lista-administradores'
          );
        });
      } else {
        this.alertService.error(resp.message);
      }
    });
  }

  onSubmitResetContrasena() {
    this.autenticacionService
      .restablecerConstraseniaCorreoElectronico(
        this.dataUsuario.data.Correo_electronico
      )
      .subscribe({
        next: resp => {
          this.alertaModalService.exito(
            this.tableText['solicitud_enviada'],
            this.tableText['srevisar_correo']
          );
        },
        error: error => {
          this.alertaModalService.error(
            this.tableText['error_solicitud'],
            error.error.message
          );
        },
      });
  }
}
